import AlertManager from '../../managers/alert/alert-manager';
import AlertTypes from '../../managers/alert/alert-types';

import Popup from '../../components/popup';

import { DeleteButton, CancelButton } from '../../components/buttons';

export default ({ setPopup, onConfirm }) => {
    return (
        <Popup type="new-version">
            <div class="popup__inner">
                <h1>Are you sure you want to delete this application</h1>

                <div class="popup__buttons">
                    <DeleteButton responsive={false} onClick={onConfirm}/>
                    <CancelButton responsive={false} onClick={() => setPopup(false)}/>
                </div>
            </div>
        </Popup>
    )
}
